import { useState, useCallback } from 'react';
import { pinService } from '@/features/card/services/cardService/pinService';
import type { ChangePinRequest, UseChangePinReturn } from '@/features/card/types/card.types';
import { useSpinner } from '@chikara/ui';
import { t } from '@/i18n';


export const useManagePin = (): UseChangePinReturn => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const [error, setError] = useState<string | null>(null);

    const changePin = useCallback(async (payload: ChangePinRequest): Promise<{ success: boolean; error?: string }> => {
        show();
        setError(null);
        try {
            await pinService.changePin(payload);
            return { success: true };
        } catch (err: any) {
            const errorMessage = err?.message || t('dashboard.card.detail.modals.changeNip.errors.generic');
            setError(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            hide();
        }
    }, []);

    return {
        changePin,
        isLoading: isSpinnerLoading,
        error
    };
};
